<template>
    <div class="hello">
        <h1>{{ msg }}</h1>
        <p>
            自助寻爱，找到合适你的人,<br>
            多重认证资料，为你建立专属私密征婚档案,<br>
            线下门店全直营，全程为你提供高品质、全方位的高端婚恋服务<br>
        </p>
        <h3>Download the app</h3>
        <ul>
            <li><router-link to="/download">APP下载</router-link></li>
            <li><a href="https://www.aiyizhan.com" target="_blank" rel="noopener">爱驿站官网</a></li>
        </ul>

    </div>
</template>

<script>
export default {
    name: 'HelloWorld',
    props: {
        msg: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}
</style>
